import {useCan} from '@/shared/hooks/use-permissions'
import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteConsumables} from '@/modules/products/consumables/api'
import {ConsumablesFilters, ConsumablesTable} from '@/modules/products/consumables/components'
import {ConsumablesSearchSchema} from '@/modules/products/consumables/schemas'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'
import {useCallback} from 'react'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'

export const Route = createFileRoute('/configuration/products/consumables/')({
  beforeLoad: requirePermission('catalogue.view'),
  component: ConsumablesPage,
  validateSearch: ConsumablesSearchSchema,
})

const LIMIT = 50

function ConsumablesPage() {
  const canManageCatalogue = useCan('catalogue.manage')
  const navigate = useNavigate()
  const search = Route.useSearch()
  const [sort] = search.sort

  const infinite = useGetInfiniteConsumables({
    limit: LIMIT,
    filters: {
      search: search.filters?.search,
      categories: search.filters?.categories,
      status: [],
    },
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinite

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <ResourcesIndexPageHeader {...(canManageCatalogue ? {addNewTo: '/configuration/products/consumables/new'} : {})}>
        <ConsumablesFilters />
      </ResourcesIndexPageHeader>
      <ResourcesIndexPageTable>
        <ConsumablesTable
          virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
          table={{onSortingChange, state: {sorting: search.sort}}}
        />
      </ResourcesIndexPageTable>
    </>
  )
}
